import { render, staticRenderFns } from "./AdminStrade.vue?vue&type=template&id=e3aca60c&scoped=true"
import script from "./AdminStrade.vue?vue&type=script&lang=js"
export * from "./AdminStrade.vue?vue&type=script&lang=js"
import style0 from "./AdminStrade.vue?vue&type=style&index=0&id=e3aca60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3aca60c",
  null
  
)

export default component.exports